import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/shared/services/data.svc';
import { HelperService } from 'src/app/shared/services/helper.svc';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  public show: boolean = false;
  token: any;
  email: any;
  password: any;
  retypePassword: any;
  resetPasswordForm: FormGroup;

  constructor(private route: ActivatedRoute, private svcHelper: HelperService, 
    private svcData: DataService, private router: Router, private fb: FormBuilder) { }

  ngOnInit() {
    this.email = this.route.snapshot.params.email;
    this.token = this.route.snapshot.params.token

    this.resetPasswordForm = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(6), Validators.pattern(StrongPasswordRegx)]],
      confirmPassword: ['', [Validators.required]]
    }, { validator: this.passwordMatchValidator });
    

    var _arg = {
      email: this.email
    }

    this.svcData.forgotPasswordTokenGet(_arg).subscribe(res => {
      if(res.status == "OK"){
        console.log(res.data);
        if(res.data[0].token != this.token){
          alert("Token expired.")
          this.router.navigate(['/auth/login']);
        }
      }
    })

  }

  get passwordFormField() {
    return this.resetPasswordForm.get('password');
  }

  passwordMatchValidator(frm: FormGroup) {
    return frm.controls['password'].value === frm.controls['confirmPassword'].value
      ? null : { mismatch: true };
  }

  showPassword() {
    this.show = !this.show;
  }

  resetPassword(){

    if (this.resetPasswordForm.valid) {
      const password = this.resetPasswordForm.value.password;    

      var _email = this.svcHelper.aesEncrypt(this.email.toString());
      var _password = this.svcHelper.aesEncrypt(password.toString());

      var _arg = {
        email: _email,
        password: _password
      }
      this.svcData.resetPassword(_arg).subscribe(res => {
        if(res.status == "OK"){
          alert("Password reset.");
          this.router.navigate(['/auth/login']);
        }
      });
    }
  }

}


export const StrongPasswordRegx: RegExp =
  /^(?=[^A-Z]*[A-Z])(?=[^a-z]*[a-z])(?=\D*\d).{8,}$/;